import { render, staticRenderFns } from "./Colleagues.vue?vue&type=template&id=069b4acc"
import script from "./Colleagues.vue?vue&type=script&lang=js"
export * from "./Colleagues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports